<template>
    <transition name="fade">
        <div
            class="bg-dark-blue bg-opacity-75 fixed inset-0 z-50 w-full h-full overflow-hidden"
            v-show="show"
            @click="$emit('close')"
        >
            <div class="w-full h-full flex justify-center items-center">
                <div
                    class="relative w-11/12 xs:w-10/12 sm:max-w-screen-sm bg-white p-4 flex justify-center items-center flex-col"
                    v-show="show"
                    @click.stop
                >
                    <button
                        type="button"
                        class="absolute top-0 right-0 -mt-3 -mr-3"
                        @click="$emit('close')"
                    >
                        <span class="fa-stack">
                            <i class="fa-solid fa-circle fa-stack-2x text-light-blue"></i>
                            <i class="fa-solid fa-xmark fa-stack-1x fa-inverse text-white"></i>
                        </span>
                    </button>
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ["name", "show"],
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
</style>